import { SearchEngine, UrlManager, buildUrlManager } from '@coveo/headless';

export const urlManagerController = (engine: SearchEngine, fragment: string): UrlManager => {
  return buildUrlManager(engine, {
    initialState: { fragment },
  });
};
